import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import ModalList from '../../common/Modal/ModalList';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>R1SE - Gaming tournament platform</h1>
			<div className='project-popup__description '>
				R1SE is a gaming tournament platform that allows users to compete with
				players from all over the world. <br />
				It works with the PC version of{' '}
				<a href='https://assettocorsa.gg/' target='_blank' rel='noreferrer'>
					Assetto Corsa
				</a>
				.<br />
				R1SE allows users to engage in single races or competitive tournaments for
				the chance to win cash or sponsor prizes. Also, it provides the option for
				free races, ensuring that gamers of all skill levels can enjoy the gaming on
				their own terms.
				<br />
				<br />
				We worked in a small team of four senior developers. <br /> I was involved in
				various aspects of the R1SE platform, encompassing the Main Frontend, Admin
				Panel, Client App, and Nest.js Backend. While I contributed across the board,
				my main achievements mostly reside within the R1SE Frontend repository.
				<br />
				<br />
				My area of responsibility:
				<ModalList disc>
					<li>
						Frontend architecture, best practices, project performance, new features,
						bug fixes, code review, and technical solutions;
					</li>
				</ModalList>
				Main achievements:
				<ModalList disc>
					<li>
						Refactored existing repositories, removed unused code and libraries;
					</li>
					<li>
						Set up proper development work-flow with type-checking, linting and
						git-hooks for repositories;
					</li>
					<li>
						Set up Redux architecture (redux-toolkit + redux-sagas) for the Main
						Frontend with the data normalization technique;
					</li>
					<li>Set up WebSockets architecture using socket.io and redux-sagas;</li>
					<li>
						Created a common library for shared components with Storybook and moved
						repeated components there;
					</li>
					<li>Optimized bundle sizes and initial loading of the platform;</li>
					<li>Developed the core frontend repository functionality of R1SE;</li>
					<li>
						Delivered a large number of functionality to other R1SE repositories;
					</li>
				</ModalList>
			</div>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						<br />
						Main front-end: TypeScript, Next.js, React.js, Redux (Redux-toolkit +
						Redux sagas middleware), Web-sockets (socket.io), MaterialUI, Storybook,
						Sentry;
						<br />
						Admin panel front-end: TypeScript, React.js, Redux, MaterialUI, Formik,
						Recharts;
						<br />
						Client windows app: Electron.js, TypeScript, React.js, Redux, MaterialUI;
						<br />
						Backend app: Node.js (Nest.js + TypeScript), Web-sockets (socket.io),
						PostgreSQL (sequelize), Redis, Passport.js (passport-steam), Docker;
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/P6rLpdEda70'
					title='R1SE - Gaming tournament platform'
				/>
			</div>
			<div className='project-popup__buttons'>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
